import { gql } from '@apollo/client';
import { DealConfiguratorFragment } from '../fragments/DealConfiguratorFragment';
/**
 * @const UpdateDealMutation
 * @since 1.0.0
 */
export const UpdateDealMutation = gql `
  mutation UpdateDealMutation($input: UpdateDealInput!) {
    updateDeal(input: $input) {
      ...DealConfiguratorFragment
    }
  }

  ${DealConfiguratorFragment}
`;
